import { exists } from 'src/app/functions/exists';
import { NavItemViewModel } from '../nav-item-view-model';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { CompanyDomainModel } from '../../../../../../domainModels/company-domain-model';
import { LocationDomainModel } from '../../../../../../domainModels/location-domain-model';
import { UserDomainModel } from '../../../../../../domainModels/user-domain-model';

@Injectable()
export class SettingsNavItemViewModel extends NavItemViewModel {
  constructor(
    private companyDomainModel: CompanyDomainModel,
    private locationDomainModel: LocationDomainModel,
    private userDomainModel: UserDomainModel,
    router: Router
  ) {
    super(router);
  }

  private readonly isAdmin$ = this.userDomainModel.hasAdminAccess$;

  protected readonly incompleteProductCategoriesCount$ = combineLatest([
    this.companyDomainModel.companyConfiguration$,
    this.companyDomainModel.inventoryProvider$,
    this.locationDomainModel.locationId$
  ]).pipe(
    map(([config, inventoryProvider, locationId]) => {
      return config?.getUnassignedProductCategories(inventoryProvider, locationId)?.length ?? 0;
    }),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  protected readonly incompleteLocationsCount$ = this.locationDomainModel.incompleteLocationsCount$;

  public readonly notificationsCount$ = combineLatest([
    this.incompleteProductCategoriesCount$,
    this.incompleteLocationsCount$,
    this.isAdmin$
  ]).pipe(
    map(([incompleteCategoriesCount, incompleteLocationsCount, isAdmin]) => {
      if (!isAdmin) return null;
      const totalCount = incompleteCategoriesCount + incompleteLocationsCount;
      if (totalCount === 0) return null;
      return totalCount > 100 ? '100+' : totalCount?.toString();
    }),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly hasNotifications$ = this.notificationsCount$.pipe(map(count => exists(count)));
}
